import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken, getUserProfile, setUserProfile } from '@/utils/auth'
import { getCurrentUser } from '@/api/c/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/login')
  },
  {
    path: '/',
    redirect: '/xiaoyunque/index'
  },
  {
    path: '/xiaoyunque/index',
    name: 'xiaoyunque',
    component: () => import('@/views/xiaoyunque/index')
  },
  {
    path: '/xiaoyunque/detail/scenes',
    name: 'xiaoyunqueScenes',
    component: () => import('@/views/xiaoyunque/detail/scenes')
  },
  {
    path: '/xiaoyunque/detail/script',
    name: 'xiaoyunqueScript',
    component: () => import('@/views/xiaoyunque/detail/script')
  },
  {
    path: '/xiaoyunque/detail/video',
    name: 'xiaoyunqueVideo',
    component: () => import('@/views/xiaoyunque/detail/video')
  },
  {
    path: '/xiaoyunque/edit',
    name: 'xiaoyunqueVideoEdit',
    component: () => import('@/views/xiaoyunque/edit')
  },
  {
    path: '/xiaoyunque/myAssets',
    name: 'xiaoyunqueMyAssets',
    component: () => import('@/views/xiaoyunque/myAssets')
  },
  {
    path: '/xiaoyunque/myProject',
    name: 'xiaoyunqueMyProject',
    component: () => import('@/views/xiaoyunque/myProject/index')
  },
  {
    path: '/user/profile',
    name: 'userProfile',
    component: () => import('@/views/user/profile/index')
  },
  {
    path: '/xiaoyunque/timbre/timbreList',
    name: 'xiaoyunqueTimbreScenes',
    component: () => import('@/views/xiaoyunque/timbre/timbreList')
  },
  {
    path: '/xiaoyunque/detail/script_new',
    name: 'xiaoyunqueScriptNew',
    component: () => import('@/views/xiaoyunque/detail/script_new')
  },
  {
    path: '/xiaoyunque/companyAssets',
    name: 'xiaoyunqueCompanyAssets',
    component: () => import('@/views/xiaoyunque/companyAssets')
  },
  {
    path: '/xiaoyunque/scriptManage',
    name: 'scriptManage',
    component: () => import('@/views/xiaoyunque/scriptManage/index')
  },
  {
    path: '/xiaoyunque/canvas',
    name: 'xiaoyunqueCanvas',
    component: () => import('@/views/xiaoyunque/canvas/index')
  },
]

const router = new VueRouter({
  routes
})

const whiteList = ['/login']

router.afterEach((to) => {
  const isDetailPage = to.path.startsWith('/xiaoyunque/detail/')
  const isEditPage = to.path === '/xiaoyunque/edit'
  if ((isDetailPage || isEditPage) && to.query.id) {
    document.title = `MeidaDream-${to.query.id}`
  } else {
    document.title = 'MeidaDream'
  }

  // 跳转路由时刷新用户信息和积分
  const token = getToken()
  if (token) {
    getCurrentUser().then(res => {
      if (res && res.data) {
        const user = res.data
        const profile = getUserProfile() || {}
        setUserProfile({ ...profile, ...user })
        // 触发全局事件，通知组件（如 left.vue）更新用户信息
        if (router.app) {
          router.app.$emit('user-profile-updated', user)
        }
      }
    }).catch(err => {
      console.error('刷新用户信息失败:', err)
    })
  }
})

router.beforeEach((to, from, next) => {
  const token = getToken()

  if (to.path === '/xiaoyunque/canvas' && process.env.VUE_APP_AI_CANVAS_ENABLED === 'false') {
    next({ path: '/xiaoyunque/myProject' })
    return
  }

  if (to.path === '/xiaoyunque/canvas') {
    const projectId = to.query.projectId || to.query.id
    if (!projectId) {
      next({ path: '/xiaoyunque/myProject' })
      return
    }
    if (!to.query.projectId) {
      const query = { ...to.query, projectId: String(projectId) }
      delete query.id
      next({
        path: '/xiaoyunque/canvas',
        query,
        replace: true,
      })
      return
    }
  }

  if (token && to.path === '/login') {
    next({ path: '/xiaoyunque/index' })
    return
  }

  // 资产库页面权限控制：仅 team=1/2 或总监可访问
  if (token && to.path === '/xiaoyunque/companyAssets') {
    const profile = getUserProfile() || {}
    const auth = profile.auth != null ? Number(profile.auth) : 0
    const team = profile.team != null ? Number(profile.team) : 0
    if (auth !== 1 && team !== 1 && team !== 2) {
      next({ path: '/xiaoyunque/index' })
      return
    }
  }

  if (token || whiteList.includes(to.path)) {
    next()
    return
  }

  next({
    path: '/login',
    query: {
      redirect: to.fullPath
    }
  })
})

export default router
